<template>
    <div class="order-items--container">
        <table class="table table-striped">
            <thead>
            <tr>
                <th>Description</th>
                <th>Quantity</th>
                <th>Price</th>
            </tr>
            </thead>
            <tbody>
            <tr v-if="!order.items.length">
                <td colspan="4" class="text-center">
                    No Items found
                </td>
            </tr>
            <tr v-for="item in order.items" v-if="order.items.length">
                <td>{{ item.name }}</td>
                <td>{{ item.quantity }}</td>
                <td>${{ item.price }}</td>
            </tr>

            <tr v-for="tax_line in order.tax_lines" v-if="order.tax_lines.length">
                <th></th>
                <th>{{ tax_line.name }}</th>
                <th>${{ tax_line.amount }}</th>
            </tr>
            <tr v-for="shipping_line in order.shipping_lines" v-if="order.shipping_lines.length">
                <th></th>
                <th>Shipping ({{ shipping_line.name }})</th>
                <th>${{ shipping_line.amount }}</th>
            </tr>
            <tr>
                <th></th>
                <th>Total</th>
                <th>${{ total_price() }}</th>
            </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
export default {
  props: ['order'],
  methods: {
    total_price(){
      const {items, tax_lines, shipping_lines} = this.order;
      let total_price = 0.00;
      if(Array.isArray(items)){
        total_price = items.reduce((total, current) => {
          return total + parseFloat(current.price)
        }, 0);
      }
      if(Array.isArray(tax_lines)){
        total_price += tax_lines.reduce((total, current) => {
          return total + parseFloat(current.amount)
        }, 0);
      }
      if(Array.isArray(shipping_lines)){
        total_price += shipping_lines.reduce((total, current) => {
          return total + parseFloat(current.amount)
        }, 0);
      }
      return total_price.toFixed(2);
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Orders/OrderItems.vue